import { render, staticRenderFns } from "./ArceClients.vue?vue&type=template&id=39135033&"
import script from "./ArceClients.vue?vue&type=script&lang=js&"
export * from "./ArceClients.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports